import * as React from "react";
import {
  EditComponent,
  CreateComponent,
  CustomComponentProps,
} from "src/components/common/Component";

export function NewsletterEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["email"]} children={children} />;
}

export function NewsletterCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"newsletter"} children={children} />;
}
